import React, { useState } from 'react';
import axios from 'axios';

import {
  OuterLogIn,
  LogInHeader
} from './styles';
import HudsonLogo from '../../components/hudsonlogos-01.png';
import LinkButton from '../../components/LinkButton';
import PasswordInput from '../../components/PasswordInput';
import MediaButtons from '../../components/MediaButtons';
import MediaInputs from '../../components/MediaInputs';
import { useUserContext } from '../../context/UserContext';
import { useHistory } from 'react-router-dom';
import AuthenticationLayout from './AuthenticationLayout';

const LogIn = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [notMatch, setNotMatch] = useState(false);
  const [isNotAuthenticated, setIsNotAuthenticated] = useState(false);
  const [showInternalMessage, setShowInternalMessage] = useState(false);

  const history = useHistory();
  const { setUserContext } = useUserContext();
  function handleClick(e: any) {
    if (e.key === 'Enter') {
      onLoginSubmit();
    }
  }
  const onLoginSubmit = async () => {
    if (notMatch || (email === '' || password === '') || showInternalMessage) {
      return;
    }
    await axios
      .post(`/api/clientaccount/Login`, {
        email,
        password,
      })
     
       const isAuthenticated = await setUserContext();
        if(isAuthenticated)
        {
          history.push('/home')
        }
      else{
        setIsNotAuthenticated(true);
      }
  };

  const onEmailBlur = async (email: string) => {
    const { data } = await axios.get(
      `/api/clientaccount/isinternalemail?email=${email}`
    );
    if (data.isInternal) {
      setShowInternalMessage(true);
    }
  };
  return (
    <AuthenticationLayout>
      <OuterLogIn maxHeight='596px' onKeyDown={handleClick}>
        <div
          style={{
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{ textAlign: 'left' }}>
            <img src={HudsonLogo} style={{ width: 105, height: 42 }} alt='' />
            <>
              <LogInHeader>Log In</LogInHeader>
              <MediaInputs
                widthMobile='318px'
                widthDesktop='416px'
                inputType={isNotAuthenticated ? 'InputError' : 'InputBase'}
                placeholder='Email'
                value={email}
                onChange={(e: any) => setEmail(e.target.value)}
                labelText='Email'
                isColor={isNotAuthenticated}
                onBlur={(e: any) => onEmailBlur(e.target.value)}
              />
              {showInternalMessage && (
                <span style={{ color: '#c50e29' }}>
                  It seems that you are an internal Hudson user. Please click
                  <span>
                    <a href='https://internal.hudsonsearch.com/logininternal'> here </a>
                  </span>to log in.
                </span>
              )}
              <PasswordInput
                labelText='Password'
                onChange={(value) => setPassword(value)}
                value={password}
                isBottomText={isNotAuthenticated}
                bottomText='Incorrect Combination'
                isColor={isNotAuthenticated}
              />
              <MediaButtons
                widthMobile='318px'
                widthDesktop='416px'
                buttonText='Log In'
                buttonType={showInternalMessage ? 'ButtonPrimaryTwoLargeDisabled' : 'ButtonPrimaryTwoLarge'}
                onClick={onLoginSubmit}
              />
              <LinkButton linkText='Forgot Password' href='/forgot-password' />
              <div style={{marginTop:24, fontSize:12}}>Don’t have an account? Email us at 
              <a
              href="mailto:orders@hudsonsearch.com?subject=Create Account"
              style={{ marginLeft: 4, marginRight: 4 }}
            >
              orders@hudsonsearch.com
            </a>
              to get started.</div>
            </>
          </div>
        </div>
      </OuterLogIn>
    </AuthenticationLayout>
  );
};

export default LogIn;
